var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,17l4-4l-4-4l-4,4L14,17z M8,28c-1.1,0-2.1-0.4-2.8-1.2C4.4,26.1,4,25.1,4,24V6c0-1.1,0.4-2.1,1.2-2.8C5.9,2.4,6.9,2,8,2h32c1.1,0,2.1,0.4,2.8,1.2C43.6,3.9,44,4.9,44,6v18c0,2.2-1.8,4-4,4h-6.5c0.2-0.7,0.3-1.3,0.4-2c0.1-0.7,0.1-1.3,0-2h6V6H8v18h6.1c-0.1,0.7-0.1,1.3,0,2c0.1,0.7,0.2,1.3,0.4,2H8z M33,14c0.8,0,1.6-0.3,2.1-0.9c1.2-1.2,1.2-3.1,0-4.2c0,0,0,0,0,0c-1.2-1.2-3.1-1.2-4.2,0C30.3,9.4,30,10.2,30,11c0,0.8,0.3,1.6,0.9,2.1C31.4,13.7,32.2,14,33,14z M10,46v-4.2c0-1.2,0.4-2.3,1-3.2c0.6-1,1.5-1.8,2.6-2.2c1.6-0.8,3.3-1.3,5.1-1.7c3.5-0.8,7.2-0.8,10.7,0c1.8,0.4,3.5,1,5.1,1.7c1,0.5,1.9,1.3,2.5,2.2c0.6,1,1,2.1,1,3.2V46H10z M14,42h20v-0.2c0-0.4-0.1-0.8-0.3-1.1c-0.2-0.3-0.5-0.6-0.9-0.8c-1.4-0.6-2.8-1.1-4.3-1.5c-2.9-0.7-6-0.7-8.9,0c-1.5,0.4-2.9,0.9-4.3,1.5c-0.4,0.2-0.7,0.4-0.9,0.8c-0.2,0.3-0.3,0.7-0.4,1V42z M24,32c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S27.9,32,24,32z M24,28c1.7,0,3-1.3,3-3c0-0.8-0.3-1.6-0.9-2.1c-1.2-1.2-3.1-1.2-4.2,0c0,0,0,0,0,0c-1.2,1.2-1.2,3.1,0,4.2C22.4,27.7,23.2,28,24,28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.8e275bb853ba4ec7870e7105d14bf632.svg";
export { ForwardRef as ReactComponent };